import React from 'react';
import styled from 'styled-components';

import Avatar from '../../Avatar';
import { Text } from '../../Typography';
import theme from '../../theme';

type ContactItemLayoutProps = {
  avatarUser: {
    firstName: string;
    lastName: string;
    avatarFilestackId?: string;
  };
  mainText: string;
  subTextOne?: string;
  subTextTwo?: string;
};

const ContactItemLayout: React.FC<ContactItemLayoutProps> = ({
  avatarUser,
  mainText,
  subTextOne,
  subTextTwo,
}) => (
    <StyledLayoutGrid>
      <Avatar user={avatarUser} width={36} />
      <StyledTextContainer>
        <StyledMainText strong>{mainText}</StyledMainText>
        {subTextOne && <StyledSubTextOne>{subTextOne}</StyledSubTextOne>}
        {subTextTwo && <StyledSubTextTwo>{subTextTwo}</StyledSubTextTwo>}
      </StyledTextContainer>
    </StyledLayoutGrid>
  );

export default ContactItemLayout;

const StyledLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 14px;
`;

const StyledTextContainer = styled.div``;

const StyledMainText = styled(Text)`
  display: block;
`;

const StyledSubTextOne = styled.div`
  font-size: 12px;
  color: ${theme.gray8};
`;

const StyledSubTextTwo = styled.div`
  font-size: 12px;
  color: ${theme.gray7};
`;
